import axios from "axios";
import Swal from "sweetalert2";


export const getRewardsStats = async () => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/rewards/stats",    
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

export const showRewards = async (id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        `/v1/admin/rewards/${id}`,    
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
export const getRewardsDashboard = async () => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/rewards/dashboard",    
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
    export const getRewards = async (filters = {}) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/rewards",    
      
        {
          params: {
            search: filters.search,
            country_id: filters.countryId
          },
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
;
    export const getRewardsredemption = async (filters = {}) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/rewards/redemption",    
      
        {
          params: {
            search: filters.search,
            country_id: filters.countryId
          },
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

  export const postRewards = async (postData) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/rewards",    
        postData,
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
    export const postResetLoyalty = async (postData) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/loyality/reset",    
        postData,
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

    export const updateRewards = async (postData ,id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        `/v1/admin/rewards/${id}`,    
        postData,
        {
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };




   export const deleteReward = async (rewardId) => {
    const brear = localStorage.getItem("token");
    const result = await Swal.fire({
      title: "هل انت متأكد ؟",
      text: "سيتم الحذف",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Okay",
    });
    if (result.isConfirmed) {
      try {
        const { data } = await axios.delete( `/v1/admin/rewards/${rewardId}`, {headers:{
 Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          
        }
         
        });
        if (data.success === true) {
          Swal.fire("Deleted!", `${data.message}`, "success");
        } else {
          Swal.fire("Not deleted", `${data.message}`, "info");
        }
        return data;
      } catch (error) {
        throw error;
      }
    }
  };